export const trimPhone = (phone?: string): string | undefined => {
  return phone ? phone.replace(/[^\d]/g, '') : undefined;
};

// Formats 10-digit phone number to display format: 123-456-7890
export const formatPhoneNumberDisplay = (input: string): string => {
  return `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`;
};

// Normalizes phone number to E.164 format with +1 country code: +11234567890
export const formatPhoneNumberE164 = (phoneNumber: string) => {
  const result = phoneNumber.replace(/\D/g, '');
  return result.startsWith('+1') ? result : '+1' + result;
};
